import { UIComponentProps, UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler } from '../uicomponent';

import { BaseContext } from '../../../utils/basecontext';

import { UIComponentView } from '../uicomponentview';

import { PaginationViewImpl } from './paginationview';

import { UIComponentCSSStyle } from '../uicomponentcss';

import { PaginationCSSStyleImpl } from './paginationcss';
import { PaginationListViewModel, PaginationListViewModelImpl } from '../verticallist/paginationverticallist/paginationlistviewmodel';

export interface PaginationComponentProps<T> extends UIComponentProps
{
    // paginationState: PaginationComponentState;
    // offset: number;
    listViewModel: PaginationListViewModel<T>;
    onPageSelected(startIndex: number, offset: number): void;
}

export interface PaginationComponentState extends UIComponentState
{
//    totalNoOfPages: number;
   currentPageNo: number;
   startIndex: number;
//    startPageNo: number;
//    endPageNo: number;
   arrowSelected: string;
   isLeftArrowEnabled: boolean;
   isRightArrowEnabled: boolean;
}

export interface PaginationComponentHandler extends UIComponentHandler
{
   onPageSelect(selectedPageNo: number): void;
   onLeftArrowSelect(): void;
   onRightArrowSelect(): void;
}

export class PaginationComponent<T> extends UIComponentImpl<PaginationComponentProps<T>,
PaginationComponentState, UIDataModel> implements PaginationComponentHandler
{
    constructor(props: PaginationComponentProps<T>)
    {
        super(props);

        // this.state = {currentPageNo: 1, startIndex: 0, isLeftArrowEnabled: false, 
        //         isRightArrowEnabled: true, arrowSelected: "right"};
        this.state = this.props.listViewModel.getPaginationState();

        // let totalNoOfPages = this.getTotalNumberOfPages();

        // console.log("total: " + props.totalItemsCount);
        
        // this.state = {totalNoOfPages: Math.round(totalNoOfPages), 
        //     currentPageNo: totalNoOfPages > 0 ? 1 : 0, isLeftArrowEnabled: false, 
        //     isRightArrowEnabled: totalNoOfPages > 4  ? true : false, startPageNo: 1, endPageNo: totalNoOfPages > 0 ? props.offset : 0};
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new PaginationViewImpl<T>(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new PaginationCSSStyleImpl(applicationContext);
    }

    // componentWillReceiveProps(props: PaginationComponentProps<T>)
    // {
    //     console.log("-----old state: " + JSON.stringify(this.state));
    //     console.log("-----new state: " + JSON.stringify(props.listViewModel.getPaginationState()));
    //     // props.listViewModel.resetPaginationState();

    //     this.setState(props.listViewModel.getPaginationState());
    // }

    onPageSelect(selectedPageNo: number): void 
    {
        // this.props.onPageSelected(this.state.currentPageNo + this.props.offset, this.props.offset);

        // this.setState({currentPageNo: selectedPageNo});
    }

    onLeftArrowSelect(): void 
    {
        let startIndex = ((this.state.startIndex * this.props.listViewModel.getOffset()) - this.props.listViewModel.getOffset() + 1);
        this.props.onPageSelected(startIndex, this.props.listViewModel.getOffset());

        this.setState({arrowSelected: "left"});
       
        // if(this.state.startPageNo > 1)
        // {
        //     this.setState({isRightArrowEnabled: true, 
        //         isLeftArrowEnabled: this.state.endPageNo === this.state.totalNoOfPages ? false: true,
        //         endPageNo: this.state.endPageNo - this.props.offset, 
        //                 startPageNo: this.state.startPageNo - this.props.offset});
        // }
        // else
        // {
        //     this.setState({isLeftArrowEnabled: false});
        // }
    }

    onRightArrowSelect(): void 
    {
        let startIndex = ((this.state.startIndex * this.props.listViewModel.getOffset()) + this.props.listViewModel.getOffset() + 1);
        this.props.onPageSelected(startIndex, this.props.listViewModel.getOffset());

        this.setState({arrowSelected: "right"});


        // if(this.state.totalNoOfPages !== this.state.endPageNo)
        // {
        //     this.setState({isLeftArrowEnabled: true, isRightArrowEnabled: this.state.endPageNo === this.state.totalNoOfPages ? false: true,
        //         endPageNo: this.state.endPageNo + this.props.offset, startPageNo: this.state.endPageNo + 1});
        // }
        // else
        // {
        //     this.setState({isRightArrowEnabled: false});
        // }
    }

    updatePaginationCount()
    {
        console.log("------updatePaginationCount");
        this.state.arrowSelected === "right" ? this.updateRightCount() : this.updateLeftCount();
      
        (this.props.listViewModel as PaginationListViewModelImpl<T>).setPaginationState(this.state);
    }

    resetPaginationCount()
    {
        console.log("------resetPaginationCount");
        this.setState((this.props.listViewModel as PaginationListViewModelImpl<T>).getPaginationState());
    }

    private updateLeftCount()
    {
        this.setState({currentPageNo: (this.state.currentPageNo - 1), startIndex: this.state.startIndex - 1,
            isLeftArrowEnabled: this.state.startIndex <=1 ? false : true, isRightArrowEnabled:
           (this.props.listViewModel as PaginationListViewModel<T>).getListOfDatas().length >= this.props.listViewModel.getOffset() 
           ? true :  false});
    }

    private updateRightCount()
    {

        this.setState({currentPageNo: (this.state.currentPageNo + 1), startIndex: this.state.startIndex + 1,
            isLeftArrowEnabled: this.state.currentPageNo >= 1 ? true : false,
            isRightArrowEnabled:
            (this.props.listViewModel as PaginationListViewModel<T>).getListOfDatas().length >= this.props.listViewModel.getOffset() 
            ? true :  false});
    }

    // private getTotalNumberOfPages(): number
    // {
    //     return this.props.totalItemsCount > 0   ?
    //   (this.props.totalItemsCount % this.props.offset) !== 0 ? 
    //                         (this.props.totalItemsCount / this.props.offset + 1) 
    //                         : (this.props.totalItemsCount / this.props.offset)
    //             : 0;
    // }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/pagination/paginationcomponent.tsx